const renewalDetailsFormatter = (data, renewalData) => {

  const dataSet = data;
  dataSet["id"] = renewalData?.pan_id
  return dataSet;
};

  export default renewalDetailsFormatter;
  